module.exports = __webpack_public_path__ + "static/media/Madfit-3.35316f8c.jpg";